import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DOMAIN } from "../../consts";
import { logout, USER_ID } from "../../session";

const MenuResponsive: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const [menuIsVisible, setMenuIsVisible] = useState(false);

  const links = [
    ...(USER_ID
      ? []
      : [
          {
            label: "Home",
            onClick: () => {
              window.location.replace(DOMAIN);
            },
          },
        ]),
    { label: "Tracking", onClick: () => navigate("/track-a-shipment") },
    ...(USER_ID
      ? [{ label: "Shipments", onClick: () => navigate("/") }]
      : [
          {
            label: "Request a quote",
            onClick: () => navigate("/request-a-quote"),
          },
        ]),
    ...(USER_ID
      ? [{ label: "Logout", onClick: () => logout() }]
      : [{ label: "Login", onClick: () => navigate("/") }]),
  ];
  return (
    <>
      <div className="relative">
        <ul className="w-0 hidden md:w-auto md:flex justify-between gap-8">
          {links.map((item, i) => (
            <li className="h-full" key={`lg-menu-item-${i}`}>
              <article
                className={`hover:text-accent-shipzo transition-colors duration-500 uppercase font-semibold cursor-default ${
                  item.label === "Login" ? "text-accent-shipzo" : ""
                }`}
                onClick={item.onClick}
              >
                {item.label}
              </article>
            </li>
          ))}
        </ul>
        <article className="md:hidden">
          <svg
            viewBox="0 0 100 80"
            width="40"
            height="30"
            onClick={() => setMenuIsVisible((prev) => !prev)}
          >
            <rect width="100" height="10"></rect>
            <rect y="30" width="100" height="10"></rect>
            <rect y="60" width="100" height="10"></rect>
          </svg>
          <ul
            className="absolute right-0 flex flex-col bg-white rounded-md border py-2 px-4 justify-between gap-2 overflow-hidden transition-all duration-300"
            style={{
              width: menuIsVisible ? "60vw" : "0px",
              maxHeight: menuIsVisible ? "500px" : "0px",
              padding: menuIsVisible ? "8px" : "0px",
              borderWidth: menuIsVisible ? "1px" : "0px",
            }}
          >
            {links.map((item, i) => (
              <li className="h-ful" key={`sm-menu-item-${i}`}>
                <article
                  className={`hover:text-accent-shipzo transition-colors duration-500 uppercase font-semibold whitespace-nowrap bg-secondary-shipzo bg-opacity-10 w-full block p-2 rounded-md`}
                  onClick={item.onClick}
                >
                  {item.label}
                </article>
              </li>
            ))}
          </ul>
        </article>
      </div>
    </>
  );
};

export default MenuResponsive;
